module.exports = __webpack_public_path__ + "static/mbt-logo-3044889479d1f33d361e5af7ba7df931.png";